import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BulkVerifyComponent } from './bulk-verify.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigatedFromModule } from 'src/app/shared/pipes/navigated-from/navigated-from.module';
import { NavigatedFromPipe } from 'src/app/shared/pipes/navigated-from/navigated-from.pipe';
import { SearchInputModule } from 'src/app/shared/components/search-input/search-input.module';
import { BadgeModule } from 'src/app/shared/components/badge/badge.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { DateFilterModule } from 'src/app/shared/components/date-filter/date-filter.module';
import { MultiselectDropdownModule } from 'src/app/shared/components/multiselect-dropdown/multiselect-dropdown.module';
import { SchedulesFilterModule } from 'src/app/shared/components/schedules-filter/schedules-filter.module';
import { PillLoaderFullScreenModule } from 'src/app/shared/components/pill-loader-full-screen/pill-loader-full-screen.module';
import { InventoryLocationsDropdownModule } from 'src/app/shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module';
import { BulkVerifyHubService } from 'src/app/shared/services/bulk-verify-hub.service';


@NgModule({
  declarations: [BulkVerifyComponent ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NavigatedFromModule,
    SearchInputModule,
    BadgeModule,
    DatepickerInputModule,
    ButtonModule,
    DialogModule,
    DateFilterModule,
    MultiselectDropdownModule,
    SchedulesFilterModule,
    PillLoaderFullScreenModule,
    InventoryLocationsDropdownModule
  ],
  exports: [BulkVerifyComponent],
  providers: [NavigatedFromPipe, FormattedDatePipe, DatePipe, BulkVerifyHubService]
})
export class BulkVerifyModule { }
